import {
	PROJECTS_REQUEST,
	PROJECTS_SUCCESS,
	PROJECTS_APPEND_SUCCESS,
	PROJECTS_FAIL,
	ALL_PROJECTS_SUCCESS,
	PROJECT_OPEN_REQUEST,
	PROJECT_OPEN_SUCCESS,
	PROJECT_OPEN_FAIL,
} from "./types";
import { getRequest, postRequest, putRequest } from "../../services/axios";
export const getProjects = (props) => async (dispatch) => {
	// do  not remove props 
	try {
		dispatch({ type: PROJECTS_REQUEST });
		if (props === "logout") {
			dispatch({
				type: PROJECTS_SUCCESS,
				payload: {
					projects: [],
				},
			});
		} else {
			const response = await getRequest("/project");
			if (response?.status === 200) {
				dispatch({
					type: ALL_PROJECTS_SUCCESS,
					payload: {
						allProjects: response.data.projects,
					},
				});
			return response;
			} else {
				const { data } = response?.response
				return data;
			}
		}

	} catch (error) {
		dispatch({
			type: PROJECTS_FAIL,
			payload: {
				error:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			},
		});
	}
};

export const getProjectsByPagination = (
	props,
	limit,
	page_no,
	search,
	append = false,
	sort = "updated_desc",
) => async(dispatch) => {
    try{
		// here in project request only isLoading will be true, and other state will be same as previous state
        dispatch({type: PROJECTS_REQUEST});
		if(props === "logout"){
            dispatch({
				type: PROJECTS_SUCCESS,
				payload: {
					projects: [],
				}
			});
		}else{
			const body = {limit, page_no, search, sort};
			const response = await postRequest("/project/getUsersProjects", body);
			const resolvedResponse = response?.response || response;
			const data = resolvedResponse?.data;
			const isSuccessful =
				resolvedResponse?.status >= 200 &&
				resolvedResponse?.status < 300 &&
				data?.success === true;

			if(isSuccessful){
				const projects = data.projects;
                dispatch({
					type: append ? PROJECTS_APPEND_SUCCESS : PROJECTS_SUCCESS,
					payload: {
						projects: projects,
						totalProjects: data.total
					}
				});
				return response;
			}
			throw new Error(
				data?.error || data?.message || "Unable to load projects",
			);
		}
	}catch(error){
       dispatch({
		  type: PROJECTS_FAIL,
		  payload: {
			  error:
				error?.response?.data?.error ||
				error?.response?.data?.message ||
				error?.message ||
				"Unable to load projects",
		  }
	   });
	   return { success: false, error: error?.message || "Unable to load projects" };
	}
}

export const markProjectOpened = (projectId, isCard) => async (dispatch) => {
	dispatch({ type: PROJECT_OPEN_REQUEST });

	try {
		const response = await putRequest(`/project/${projectId}/opened`, {
			isCard: Boolean(isCard),
		});
		const data = response?.data || response?.response?.data;

		if (response?.status === 200 && data?.success) {
			dispatch({
				type: PROJECT_OPEN_SUCCESS,
				payload: {
					projectId,
					lastOpenedAt: data.lastOpenedAt,
				},
			});
			return data;
		}

		dispatch({
			type: PROJECT_OPEN_FAIL,
			payload: {
				error: data?.error || data?.message || "Unable to record project open",
			},
		});
		return data;
	} catch (error) {
		dispatch({
			type: PROJECT_OPEN_FAIL,
			payload: {
				error:
					error?.response?.data?.error ||
					error?.message ||
					"Unable to record project open",
			},
		});
		return error;
	}
};
